
export default {

  computed: {
    // 当前使用语言
    language() {
      return this.$store.state.Site.language;
    },
  },

  methods: {

    // 翻译文本
    translateText(type, needTrasArr, callback) {

      const createDartLoading = this.$toast.loading({
				duration: 0, // 持续展示 toast
				forbidClick: true,
				message: this.$t('translate.translateing')
			})

      console.log('待翻译内容', needTrasArr)

      // 要翻译的字符串数组用\n分隔
      const splitStr = '\n'
      let sendData = {
        Query: needTrasArr.join(splitStr),
        Languages: type === 'zh-cn' ? ['en', 'zh'] : ['zh', 'en']
      }

      // 通过接口获取翻译结果
      this.$api.translate(sendData).then((res) => {
        
        if (res && res.Success) {
          let resultData = res.Data.split(splitStr)
          console.log('翻译后内容', resultData)
  
          // 翻译结果数组长度和待翻译内容数组长度不一致，说明翻译失败
          if (resultData.length !== needTrasArr.length) {
            this.$toast(this.$t('translate.translateFail'));
            return
          }
          callback(resultData)
        }
      }).catch((err) => {
        
      }).finally(() => {
        setTimeout(() => {
          createDartLoading.clear()
        }, 500) 
      })
    },
  }
};